<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-1" d="m45,78.01c-18.2,0-33.01-14.81-33.01-33.01S26.8,11.99,45,11.99s33.01,14.81,33.01,33.01-14.81,33.01-33.01,33.01Zm0-61.03c-15.45,0-28.01,12.57-28.01,28.01s12.57,28.01,28.01,28.01,28.01-12.57,28.01-28.01-12.57-28.01-28.01-28.01Z"/>
  <path class="cls-2" d="m66.37,40.75l-8.12,7.91c-.56.53-.8,1.3-.68,2.07l1.93,11.17c.32,1.9-1.67,3.35-3.38,2.44l-10.05-5.26c-.67-.36-1.49-.36-2.17,0l-10.03,5.26c-1.71.91-3.71-.55-3.38-2.44l1.91-11.17c.14-.77-.12-1.54-.67-2.07l-8.12-7.91c-1.38-1.35-.62-3.71,1.3-3.98l11.21-1.62c.77-.12,1.42-.6,1.76-1.28l5.02-10.17c.85-1.73,3.31-1.73,4.17,0l5.02,10.17c.34.68.99,1.16,1.76,1.28l11.21,1.62c1.91.27,2.68,2.63,1.3,3.98Z"/>
</svg>
</template>

<script>
export default {
    name: "BrandShareIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #59c5c7;
  }
  .cls-2 {
    fill: #bce2d2;
  }
</style>